<template>
  <div class="glasses-view md-layout">
    <div class="md-layout md-layout-item md-size-5">
      <label class="eye-label">{{ eyeText }}</label>
    </div>
    <div class="md-layout md-layout-item md-size-95">
      <div class="md-layout-item md-size-20">
        <md-field style="width: 100%; max-width: 100%">
          <label class="mlabel" for="SPH" style="font-size: smaller;">Sphere</label>
          <md-input
            :id="`${type}-${eye}-SPH`"
            :min="eyeService.ValidRanges.SPH.min"
            :max="eyeService.ValidRanges.SPH.max"
            :step="eyeService.ValidRanges.SPH.step"
            v-model="rxValues.SPH"
            type="text"
            name="SPH"
            md-dense
            style="width: 100%; max-width: 100%"
            @input="changedRx($event)"
            @blur="rxValues.SPH = eyeService.preventOutOfRange($event, eyeService.ValidRanges.SPH)"
          ></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-20">
        <md-field style="width: 100%; max-width: 100%">
          <label class="mlabel" for="CYL" style="font-size: smaller;">Cylinder</label>
          <md-input
            :id="`${type}-${eye}-CYL`"
            :min="eyeService.ValidRanges.CYL.min"
            :max="eyeService.ValidRanges.CYL.max"
            :step="eyeService.ValidRanges.CYL.step"
            v-model="rxValues.CYL"
            type="text"
            name="CYL"
            md-dense
            style="width: 100%; max-width: 100%"
            @input="changedRx($event)"
            @blur="rxValues.CYL = eyeService.preventOutOfRange($event, eyeService.ValidRanges.CYL)"
          ></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-20">
        <md-field style="width: 100%; max-width: 100%">
          <label class="mlabel" for="AXS" style="font-size: smaller;">Axis</label>
          <md-input
            :id="`${type}-${eye}-AXS`"
            :min="eyeService.ValidRanges.AXS.min"
            :max="eyeService.ValidRanges.AXS.max"
            :step="eyeService.ValidRanges.AXS.step"
            v-model="rxValues.AXS"
            type="text"
            name="AXS"
            md-dense
            style="width: 100%; max-width: 100%"
            @input="changedRx($event)"
            @blur="rxValues.AXS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.AXS)"
          ></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-20">
        <md-field style="width: 100%; max-width: 100%">
          <label class="mlabel" for="POW" style="font-size: smaller;">Add</label>
          <md-input
            :id="`${type}-${eye}-POW`"
            :min="eyeService.ValidRanges.POW.min"
            :max="eyeService.ValidRanges.POW.max"
            :step="eyeService.ValidRanges.POW.step"
            v-model="rxValues.POW"
            type="text"
            name="POW"
            md-dense
            style="width: 100%; max-width: 100%"
            @input="changedRx($event)"
            @blur="rxValues.POW = eyeService.preventOutOfRange($event, eyeService.ValidRanges.POW)"
          ></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-20">
        <md-field style="width: 100%; max-width: 100%">
          <label class="mlabel" for="DIS" style="font-size: smaller;">Acuity</label>
          <span class="md-prefix">20/</span>
          <md-input
            :id="`${type}-${eye}-DIS`"
            :min="eyeService.ValidRanges.DIS.min"
            :max="eyeService.ValidRanges.DIS.max"
            :step="eyeService.ValidRanges.DIS.step"
            v-model="rxValues.DIS"
            type="text"
            name="DIS"
            md-dense
            style="width: 100%; max-width: 100%"
            @input="changedRx($event)"
            @blur="rxValues.DIS = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIS)"
          ></md-input>
        </md-field>
      </div>

      <div v-show="type === 'contact'" class="md-layout md-layout-item md-size-95" style="padding-left: 0%;">
        <div class="md-layout-item md-size-22">
          <md-field style="width: 100%; max-width: 100%">
            <label class="mlabel" for="BC" style="font-size: smaller;">Base Curve</label>
            <md-input
              :id="`${type}-${eye}-BC`"
              :min="eyeService.ValidRanges.BC.min"
              :max="eyeService.ValidRanges.BC.max"
              :step="eyeService.ValidRanges.BC.step"
              v-model="rxValues.BC"
              type="text"
              name="BC"
              md-dense
              style="width: 100%; max-width: 100%"
              @input="changedRx($event)"
              @blur="rxValues.BC = eyeService.preventOutOfRange($event, eyeService.ValidRanges.BC)"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-22">
          <md-field style="width: 100%; max-width: 100%">
            <label class="mlabel" for="DIA" style="font-size: smaller;">Diameter</label>
            <md-input
              :id="`${type}-${eye}-DIA`"
              :min="eyeService.ValidRanges.DIA.min"
              :max="eyeService.ValidRanges.DIA.max"
              :step="eyeService.ValidRanges.DIA.step"
              v-model="rxValues.DIA"
              type="text"
              name="DIA"
              md-dense
              style="width: 100%; max-width: 100%"
              @input="changedRx($event)"
              @blur="rxValues.DIA = eyeService.preventOutOfRange($event, eyeService.ValidRanges.DIA)"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-22">
          <md-field style="width: 100%; max-width: 100%">
            <label class="mlabel" for="COL" style="font-size: smaller;">Color/MF PWR</label>
            <md-input
              :id="`${type}-${eye}-COL`"
              v-model="rxValues.COL"
              type="text"
              name="COL"
              md-dense
              style="width: 100%; max-width: 100%"
              @input="changedRx($event)"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-35"></div>
      </div>
    </div>
  </div>
</template>

<script>
import EyeInfoService from "../../../../../services/eye-info.service"

export default {
  props: ["isEdit", "eye", "type", "values"],
  data() {
    return {
      eyeService: EyeInfoService,
      rxValues: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      }
    }
  },
  mounted() {
    if (this.isEdit) {
      this.fillValues()
    }
  },
  computed: {
    eyeText() {
      return this.eye.toUpperCase()
    }
  },
  methods: {
    fillValues() {
      //this.rxValues = { ...this.values }
      this.rxValues.SPH = this.eyeService.formatValue(this.values.SPH, this.eyeService.ValidRanges.SPH)
      this.rxValues.CYL = this.eyeService.formatValue(this.values.CYL, this.eyeService.ValidRanges.CYL)
      this.rxValues.AXS = this.eyeService.formatValue(this.values.AXS, this.eyeService.ValidRanges.AXS)
      this.rxValues.POW = this.eyeService.formatValue(this.values.POW, this.eyeService.ValidRanges.POW)
      this.rxValues.DIS = this.eyeService.formatValue(this.values.DIS, this.eyeService.ValidRanges.DIS)
      this.rxValues.BC = this.eyeService.formatValue(this.values.BC, this.eyeService.ValidRanges.BC)
      this.rxValues.DIA = this.eyeService.formatValue(this.values.DIA, this.eyeService.ValidRanges.DIA)
      this.rxValues.COL = this.values.COL
      this.rxValues.BRA = this.values.BRA
      this.rxValues.MAN = this.values.MAN
      this.rxValues.QT = this.eyeService.formatValue(this.values.QT, this.eyeService.ValidRanges.QT)
    },
    changedRx() {
      this.$emit("changedRx", this.rxValues)
    }
  }
}
</script>
<style>
.glasses-view {
  display: flex;
  align-items: center;
}

.eye-label {
  display: flex;
  align-items: center;
  height: 100%;
  text-align: right;
  color: black;
}
</style>
